type Props = {
  className?: string
  title: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  type?: 'button' | 'reset' | 'submit'
  children?: JSX.Element
}

export const ButtonPrimary = ({ className, title, onClick, disabled, type, children }: Props) => {
  return (
    <button
      className={`rounded-full py-2 px-4 ${
        disabled ? 'bg-slate-300 text-gray-500' : 'bg-primary-500 hover:bg-opacity-70 text-white'
      } font-semibold text-sm ${className}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {title}
      {children}
    </button>
  )
}
